import React from 'react';

import NavigationMenuItem, {CounterType} from "../../../../menu-items/menu-item";
import MyWorkGlobalLocalSettings from "../../../../../../app/home/home-local-settings";
import {EVENT_BUS_USER_LAST_VISIT_MY_WORK} from "../../../../../../core/model2/user/bus";
import {BUS_APP_LAUNCH} from "../../../../../../core/gd/app-manager/@event"

type State = {
    selected        : boolean
    totalInbox      : number
    totalInboxNew   : number    // number of new (not read yet)
}

export default class MainMenu_ItemMyWork extends React.Component<any,State> {

    constructor(props:any) {
        super(props);

        const totals = this.calculateTotals();

        this.state = {
            selected        : false,    // nado kak to chto to podumat'...
            totalInbox      : totals.inbox,
            totalInboxNew   : totals.inboxNew
        };

        // gd.bus.subscribe('route', this, this.onRoute);
        gd.bus.subscribe(BUS_APP_LAUNCH, this, this.onLaunchApp);
        gd.bus.subscribe("my-work:refresh", this, this.update);
        gd.session.myWork.folder('inbox').on('change add remove reset', this.onNotificationsChanged);

        gd.bus.subscribe(EVENT_BUS_USER_LAST_VISIT_MY_WORK, this, this.onNotificationsChanged )
    }

    componentDidMount() {
        this.updateSelection(window.location.pathname)
    }

    componentDidUpdate() {
        this.updateSelection(window.location.pathname)
    }

    componentWillUnmount = () => {
        gd.bus.unsubscribe(this);
        gd.session.myWork.folder('inbox').off('change add remove reset',this.onNotificationsChanged);
    };

    onLaunchApp = (data:any) => {
        this.updateSelection(data.path)
    }

    updateSelection = (path:string) => {
        // check for 'my-work/' because 'my-workload' also exists
        if (this.state.selected) {
            !path.includes('my-work/') && this.setState({selected: false})
        } else {
            path.includes('my-work/') && this.setState({selected: true})
        }
    }

    update = () => {
        this.forceUpdate()
    }

    onNotificationsChanged = () => {
        const totals = this.calculateTotals();

        this.setState({
            totalInbox      : totals.inbox,
            totalInboxNew   : totals.inboxNew
        });
    }

    calculateTotals() {
        const inboxNotifications = gd.session.myWork.folder('inbox');
        const lastVisitMyWork = gd.session.me.lastVisitMyWork;
        const arrInboxNew = inboxNotifications.filter((n:any)=>n.dateCreated.isAfter(lastVisitMyWork));

        return {
            inbox       : inboxNotifications.length,
            inboxNew    : arrInboxNew.length
        }
    }

    getCounter = () => {
        const isAssignedToMode = gd.session.companies.get(gd.companyId).settings.labs.myWorkAssigned;
        const localSettingsMyWorkGlobal = new MyWorkGlobalLocalSettings();
        const actionRequiredDisplayDisabled = !localSettingsMyWorkGlobal.displayItemsTypes.includes(gd.const.myWork.resourceType.ACTION_REQUIRED_TASK);
        return actionRequiredDisplayDisabled || isAssignedToMode ? 0 : this.state.totalInbox;
    }

    render() {

        const myWorkView = gd.user.personalViews.myWork

        const counterType : CounterType = this.state.totalInboxNew > 0 ? CounterType.BLUE_BOX : CounterType.GRAY_BOX

        return <NavigationMenuItem name="My Work"
                                   selected={this.state.selected}
                                   icon="i5-my-work-new"
                                   navigationSection={this.props.navigationSection}
                                   url = "my-work"
                                   counter={this.getCounter()}
                                   counterStyle={counterType}
                                   moreMenuOptions = {myWorkView.menuMoreOptions()}
                                   {...this.props} />;
    }
}
